<template>
  <v-container
    :style="this.$vuetify.breakpoint.smAndDown ? '' : 'width: 870px;'"
  >
    <LoggedInUser />
    <ManageUsers />
  </v-container>
</template>

<script>
import LoggedInUser from "@/components/LoggedInUser.vue";
import ManageUsers from "@/components/ManageUsers.vue";

export default {
  name: "Users",

  components: {
    LoggedInUser,
    ManageUsers
  }
};
</script>

<style>
@import url("../assets/styles/colors.css");
</style>

<style>
.sub-element {
  margin-bottom: 20px;
}

.sub-element-header {
  background-color: var(--GLS-blue-100);
  color: var(--GLS-white);
  padding: 0px 8px;
  margin: 0px;
}

.sub-element-content {
  background-color: var(--GLS-blue-5);
  padding: 4px 0px;
  padding-left: 12px;
  padding-right: 4px;
  padding-bottom: 6px;
}

.sub-element-icon {
  color: var(--GLS-yellow) !important;
  cursor: pointer;
}

.sub-element-button {
  background-color: var(--alt-blue) !important;
  color: var(--GLS-white) !important;
  margin-bottom: -4px;
}
</style>
